var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.accountInfoPath)?_c('el-button',{attrs:{"size":"mini","circle":""},on:{"click":_vm.userInfo}},[_c('i',{staticClass:"icon iconfont icon-people"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }